<template>
  <div>
    <h1 class="text-h5 mb-4">{{ $t('Cash Register is closed') }}</h1>
    <p>{{ $t('At the start of each business day, you must open your register and add the starting balance.') }}<br>
      {{ $t('Set an opening float to open the register and make a sale.') }}</p>
    <v-row
      class="mt-4"
      wrap
    >
      <v-col sm="3">
        <forms-cash-movements-save
          :expected-initial="expectedCash"
          :movement-type="CASH_MOVEMENT_INITIAL"
        />
      </v-col>
      <v-col
        v-if="lastClosedReport"
        sm="9"
      >
        <v-toolbar color="white">
          <v-toolbar-title>
            <v-icon class="mr-2">fal fa-calendar-alt</v-icon>
            {{ $t('Last register closure summary') }}
          </v-toolbar-title>
          <v-spacer />
          <v-progress-circular
            v-show="$wait.is('fetching last report')"
            :size="25"
            color="primary"
            indeterminate
          />
        </v-toolbar>
        <v-card tile>
          <cash-register-report-info
            :report-object="lastClosedReport"
            :show-print-button="true"
          />
        </v-card>
      </v-col>

      <!-- Dialog whether register has already been opened -->
      <v-dialog
        v-model="showAlreadyOpenedDialog"
        max-width="500"
        no-click-animation
        persistent
      >
        <v-card v-if="showAlreadyOpenedDialog && lastOpenedReport">
          <v-card-text class="pt-6">
            <v-alert
              class="text-left mb-4"
              color="primary"
              icon="fal fa-exclamation-square"
              outlined
              prominent
              text
            >
              {{ `${$t('It looks like this cash register has already been opened.')} ${$t('You can find more information about it below.')} ${$t('Are you sure you want to continue?')}` }}
            </v-alert>
            <v-list class="super-dense">
              <v-list-item>
                <v-list-item-content>{{ $t('Store') }}</v-list-item-content>
                <v-list-item-content class="align-end">{{ _.get(cashRegister, 'store.name') }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('Cash Register') }}</v-list-item-content>
                <v-list-item-content class="align-end">{{ _.get(cashRegister, 'description') }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('When') }}</v-list-item-content>
                <v-list-item-content class="align-end">{{ lastOpenedReport.timestamp | moment("D MMMM YYYY HH:mm") }}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>{{ $t('Where') }}</v-list-item-content>
                <v-list-item-content class="align-end">{{ lastOpenedReport.posSubDomain.toUpperCase() }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-btn
              text
              @click="showAlreadyOpenedDialog = false"
            >{{ $t('Continue') }}</v-btn>
            <v-spacer />
            <v-btn
              :href="lastOpenedReport.posFullDomain"
              class="font-weight-bold"
              color="primary"
              text
            >
              <v-icon
                color="primary"
                small
                class="mt-n1 mr-1"
              >
                fal fa-fw fa-cash-register
              </v-icon>  {{ $t('Go to {0}', [lastOpenedReport.posSubDomain]) }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import FormsCashMovementsSave from '@/components/forms/cash-movements/FormsCashMovementsSave'
import CashRegisterReportInfo from '@/components/cash-register-reports/CashRegisterReportInfo'
import cashRegisterService from '@/services/cash-registers'
import camelcaseKeys from 'camelcase-keys'
import { CASH_MOVEMENT_INITIAL } from '@/utils/types/cash-movement'
import * as Cookies from 'js-cookie'

export default {
  name: 'FormsCashRegistersOpen',

  components: {
    CashRegisterReportInfo,
    FormsCashMovementsSave
  },

  data: () => ({
    CASH_MOVEMENT_INITIAL,
    expectedCash: null,
    lastClosedReport: null,
    showAlreadyOpenedDialog: false,
    lastOpenedReport: null
  }),

  computed: {
    ...mapGetters(['cashRegister']),
    ...mapState(['identifier'])
  },

  created () {
    this.$wait.start('fetching last report')
    cashRegisterService.getLastClosedReport(this.identifier)
      .then((data) => {
        if (data.data.last_closed_report) {
          this.lastClosedReport = camelcaseKeys(data.data.last_closed_report, { deep: true })
          this.expectedCash = data.data.expected_cash
        }
        this.$wait.end('fetching last report')
      })
      .catch((err) => console.log(err))
  },
  mounted () {
    if (Cookies.get('cashRegisterOpened')) {
      this.lastOpenedReport = JSON.parse(Cookies.get('cashRegisterOpened'))
      this.showAlreadyOpenedDialog = true
    } else {
      this.showAlreadyOpenedDialog = false
      this.lastOpenedReport = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/cash-registers/FormsCashRegistersOpen.vue